import _u from '../../common/utility';
import _v from '../../common/vars';
import _fn from '../../common/main-fn';

//medscape specific beacon-logic
const medscape = function() {
		
	/* Override Common Beacon Default Internal Domain RegEx */
	_v.intSiteRegEx = new RegExp("(medscape|medscapestatic)\.(com|org)");

	/* Sitename / Pillar (aka wb.site / wb.chn) */
	if ((typeof _v.g['s_site'] == "undefined" || _v.g['s_site'] === "") && document.domain.indexOf("medscape") !== -1) {
		_v.g['s_site'] = "mscp";
	}

	if (document.domain.indexOf("medscape.com") !== -1) {
		_fn.wmdSetContext("wb.chn", "news and perspectives"); // default for any medscape.com page, will be overwritten as necessary below
		if (_v.s_subdomain == "academy" || window.location.pathname.indexOf('/academy/business') == 0) {
			_fn.wmdSetContext("wb.chn", "academy");
		}
		else if (_v.s_subdomain == "boards" || _v.s_subdomain == "dashboard") {
			_fn.wmdSetContext("wb.chn", "boards");
		}
		else if (_v.s_subdomain == "cme") {
			_fn.wmdSetContext("wb.chn", "education");
		}
		else if (_v.s_subdomain == "consult" || window.location.pathname.indexOf("/consult") == 0) {
			_fn.wmdSetContext("wb.chn", "consult");
		}
		else if (_v.s_subdomain == "reference" || _v.s_subdomain == "emedicine" || window.location.pathname.indexOf("/answers/") == 0) {
			_fn.wmdSetContext("wb.chn", "reference and tools");
		}
		else if (_v.s_subdomain == "profreg" || _v.s_subdomain == "login") {
			_fn.wmdSetContext("wb.chn", "registration");
		}
		else if (_v.s_subdomain == "directory" || _v.s_subdomain == "modir") {
			_fn.wmdSetContext("wb.chn", "physician directory");
		}
		else if (_v.s_subdomain == "connect") {
			_fn.wmdSetContext("wb.chn", "medscape connect");
		}
		else if (_v.s_subdomain == "search") {
			_fn.wmdSetContext("wb.chn", "search");
		}
		else if (_v.s_subdomain == "francais") {
			_fn.wmdSetContext("wb.chn", "medscape france");
		}
		else if (_v.s_subdomain == "deutsch") {
			_fn.wmdSetContext("wb.chn", "medscape germany");
		}
		else if (_v.s_subdomain == "portugues") {
			_fn.wmdSetContext("wb.chn", "medscape portuguese");
		}
		else if (_v.s_subdomain == "espanol") {
			_fn.wmdSetContext("wb.chn", "medscape spanish");
		}
		else if (_v.s_subdomain == "odp" || _v.s_subdomain == "decisionpoint") {
			_fn.wmdSetContext("wb.chn", "decision point");
		}
	}
	else if (document.domain.indexOf("medscape.org") !== -1) {
		_fn.wmdSetContext("wb.chn", "education");
	}
	else {
		_fn.wmdSetContext("wb.chn", "other");
	}

	if (_v.g['s_site'] == "medscape-fr") {
		_fn.wmdSetContext("wb.chn", "medscape france");
	}
	else if (_v.g['s_site'] == "medscape-de") {
		_fn.wmdSetContext("wb.chn", "medscape germany");
	}
	else if (_v.g['s_site'] == "medscape-pt") {
		_fn.wmdSetContext("wb.chn", "medscape portuguese");
	}
	else if (_v.g['s_site'] == "medscape-es") {
		_fn.wmdSetContext("wb.chn", "medscape spanish");
	}

	//s_channel takes precedence
	if (typeof window.s_channel !== 'undefined' && window.s_channel !== null && window.s_channel !== '') {
		_fn.wmdSetContext("wb.chn", window.s_channel);
	}

	if (typeof window.isMscpApp != "undefined" && window.isMscpApp && document.domain.indexOf("medscape") !== -1) { // Override for app AFTER checking s_site to pull wb.chn, so that app still gets correct pillar for non-US
		_v.g['s_site'] = "app-msp";
	}
	_fn.wmdSetContext('wb.site', _v.g['s_site']);

	/* PPE-67820 - Add wb.rspd + wb.brkpt contextData for Responsive pages */
	function getResponsiveWidthMetric() {
		var winWidth = window.innerWidth ? parseInt(window.innerWidth) : parseInt(document.getElementsByTagName("body")[0].parentNode.offsetWidth);
		switch (true) {
			case (winWidth < 768):
				return "320-767";
			case (winWidth > 767 && winWidth < 1024):
				return "768-1023";
			case (winWidth > 1023 && winWidth < 1280):
				return "1024-1279";
			case (winWidth >= 1280):
				return "1280-greater";
		}
		return null;
	}
	if (typeof window.s_responsive_design !== "undefined" &&  window.s_responsive_design === true && getResponsiveWidthMetric() !== null) {
		_fn.wmdSetContext('wb.rspd', 'rdesign-yes');
		_fn.wmdSetContext('wb.brkpt', getResponsiveWidthMetric());
	}
	/* /PPE-67820 - Add wb.rspd + wb.brkpt contextData for Responsive pages */

	/* 'wmdTrackerMarker' updated as per Jira PPE-2111 WR */
	window.wmdTrackerMarker = function (marker, clkurl) {
		_fn.remLinkTrackVars(['wb.dwnld','wb.exiturl','wb.cstm']); // make sure no exit url / download picked up in same call, as there is prop mapping conflict
		_fn.addLinkTrackVars(['wb.tm','wb.clkurl']);
		if (typeof marker != "undefined" && marker !== "") {
			_fn.wmdSetContext('wb.tm', marker);
		}
		if (typeof clkurl != "undefined" && clkurl !== "") {
			_fn.wmdSetContext('wb.clkurl', clkurl);
		}
		if ((typeof marker != "undefined" && marker !== "") || (typeof clkurl != "undefined" && clkurl !== "")) {
			void(s_md.tl(true, 'o'));
		}
		_fn.remLinkTrackVars(['wb.tm','wb.clkurl']); // after tracking call made, remove link-specific contextData from other calls
		_fn.wmdRemContext(['wb.tm','wb.clkurl']);
		_fn.addLinkTrackVars(['wb.dwnld','wb.exiturl','wb.cstm']);
	}

	try {
		if (window.location.href.match(/(viewarticle\/\d+_|#vp_?|#|#page=|&page=|\?page=|&pagenumber=|\?pagenumber=)(\d+)/) !== null) {
			_v.g['s_pagenum'] = window.location.href.match(/(viewarticle\/\d+_|#vp_?|#|#page=|&page=|\?page=|&pagenumber=|\?pagenumber=)(\d+)/)[2];
		}
	} catch (e) {}

	// PPE-156530 - clean up pageName for article cardinality, keep BEFORE util.urlClean function
	s_md.pageName = s_md.pageName.replace(/(viewarticle\/\d+)_\d+/,"$1").split('#')[0];

	// PPE-76771 - FAF/FPF
	if (typeof window.isFPFEligible !== "undefined" && window.isFPFEligible !== null) {
		_fn.wmdSetContext('wb.frpg', s_md.pageName);
	}

}

export default medscape;
